module.exports = __webpack_public_path__ + "static/banner_resources_mobile-d80dbaea4c30c6c48fc7a31195b6aa00.png";